import React, { useEffect, useState } from "react"
import resale from '../../assets/resale.png'
import { Link } from "react-router-dom";

const cities = ["Noida", "Gurugram", "Delhi"];

export const Resale = () => {
    const [cityIndex, setCityIndex] = useState(0);

    useEffect(() => {
        const interval = setInterval(() => {
            setCityIndex((prevIndex) => (prevIndex + 1) % cities.length);
        }, 2000)
        return () => clearInterval(interval);
    }, []);

    return (
        <div className="px-6 py-10">

            <h3 className="text-lg sm:text-xl font-bold text-gray-800 mb-8">RIGID TO RESALE</h3>


            <div class="relative w-full h-[400px] flex items-center justify-center">
                <img src={resale} alt="Image1" class="w-full h-full object-cover" />
                <div className="absolute inset-0 bg-black bg-opacity-50"></div>
                <div class="absolute inset-0 flex items-center justify-center">
                    <h1 className="text-3xl text-white sm:text-4xl md:text-5xl font-bold">
                        Exclusive Deals Coming  Soon in <br />  {" "}
                        <span className="text-green-500 transition-all duration-500">
                            {cities[cityIndex]}
                        </span>
                    </h1>
                </div>
            </div>
        </div>
    )
}